// extracted by mini-css-extract-plugin
export default {"sidebarContainer":"Sidebar_sidebarContainer__4ie-z","optionText":"Sidebar_optionText__ska+T","bigText":"Sidebar_bigText__1wqcp"};